import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-switch" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    isEnabled: { type: Boolean, default: false },
    labelText: { default: '' }
  },
  emits: ["onToggled"],
  setup(__props: any, { emit: __emit }) {



// emits
const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["toggle-switch__label", { 'toggle-switch__label--enabled': _ctx.isEnabled }])
    }, _toDisplayString(_ctx.labelText), 3),
    _createElementVNode("div", {
      class: "toggle-switch__switch",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onToggled', !_ctx.isEnabled)))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("input", {
        type: "checkbox",
        class: "toggle-switch__switch__checkbox"
      }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["toggle-switch__switch__slider", { 'toggle-switch__switch__slider--enabled': _ctx.isEnabled, 'toggle-switch__switch__slider--disabled': !_ctx.isEnabled }])
      }, null, 2)
    ])
  ]))
}
}

})